import React, { useState } from 'react';
import Content from '../../../../layout/content/Content';
import { Block, BlockHead, BlockHeadContent, BlockTitle } from '../../../../components/Component';
import PromotionsUSSDSettings from './PromotionsUSSDSettings';
import Head from '../../../../layout/head/Head';
import CardTabs from '../../../components/cards/CardTabs';

const PromotionsSettings = ({ tenant_info, user_info }) => {

 const [activeCardTab, setActiveCardTab] = useState("USSD Settings");

 // Card Tabs
 const tabs = [
  {
   tabName: "USSD Settings"
  }
 ];
 return (
  <>
   <Head title={tenant_info?.name ? `${tenant_info.name} Settings` : "Settings"} />
   <Content>
    <BlockHead size="sm">
     <BlockHeadContent>
      <BlockTitle page>Settings</BlockTitle>
     </BlockHeadContent>
    </BlockHead>
    <Block>
     <CardTabs cardTabs={tabs} activeCardTab={activeCardTab} setActiveCardTab={setActiveCardTab} />
    </Block>

    {
     activeCardTab === "USSD Settings" && (
      <>
       <PromotionsUSSDSettings tenant_info={tenant_info} user_info={user_info} />
      </>
     )
    }
   </Content>

  </>
 );
};

export default PromotionsSettings;